import '../scss/styles.scss'
import { initLoadingStates } from './loading_state'
import { initAvatarFallback } from './avatar_fallback'

initLoadingStates()
initAvatarFallback()
